const getLDContext = function(userData) {
  return {
    kind: 'user',
    key: userData?.id,
    email: userData?.email,
    type: 'LENDER_USER',
    role: userData?.role?.name,
    lender: userData?.lender?.name,
    lender_name: userData?.lender?.name,
    lender_id: userData?.lender?.id,
    _meta: {
      privateAttributes: ['email'],
    },
  }
}

const defaultAnonymousContext = {
  kind: 'user',
  anonymous: true,
  key: 'unidentified_init_user',
  name: 'init_user',
  lender_name: 'init_lender',
  email: 'init_user@reggora.com',
  type: 'LENDER_USER',
  _meta: {
    privateAttributes: ['email'],
  },
}

export { defaultAnonymousContext, getLDContext }
